module.exports = __webpack_public_path__ + "assets/img/pay_success.5a60b568.png";